<template>
  <div>
    <p class="clearfix mb-0">
      <span class="float-md-left d-block d-md-inline-block mt-25">
        COPYRIGHT © {{ new Date().getFullYear() }}
        {{ version }}
        <b-link
          class="ml-25"
          href="https://cabledelancer.com"
          target="_blank"
        >Cable Delancer</b-link>
        <span
          class="d-none d-sm-inline-block"
        >, All rights Reserved</span>
      </span>
    </p>
    <div align="center">
      <b-card-text class="text-muted">
        Aceptamos
      </b-card-text>
    </div>
    <div align="center">
      <b-img
        :src="imgFooter"
        alt="Logo"
        style="width: 300px; height: 60px"
      />
    </div>
    <div
      align="center"
      class="mt-2"
    >
      <b-img
        :src="imgPayPal"
        alt="Logo"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BCardText, BImg, BLink } from "bootstrap-vue"

export default {
  components: {
    BLink,
    BCardText,
    BImg,
  },
  data() {
    return {
      imgFooter: require("@/assets/images/logo/footer-card.png"),
      imgPayPal: require("@/assets/images/logo/paypal.png"),
      version: '',
    }
  },
  created() {
    this.version = process.env.VUE_APP_VERSION
  },
}
</script>
